
import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { parseHref } from "@/functions/global.function";

@Component
export default class AppFooter extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;

  private parseUrl(url: string) {
    return parseHref(url);
  }
}
